import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";

const ProstateTransAbdorminal = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = window.getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
  const [providerList, setProviderList] = useState([]);
 const[isLoading,setIsLoading]=useState(false)
  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    reasonForExam: "",
    bladderVolume: "",
    prostateVolume: "",
    postVoidVolume: "",
    impression: "",
    signature: "",
    preliminary: "",
  });

  // ✅ Simplified handleChange
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);

  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange("provider", data.linked_provider);   // ✅ fixed
    } else {
      handleChange("provider", providerList[0].providername);  // ✅ fixed
    }
  }
}, [providerList, data, formData.provider]);

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.reasonForExam.trim()) errors.push("Reason for Exam is required.");
    if (!formData.bladderVolume.trim()) errors.push("Bladder Volume is required.");
    if (!formData.prostateVolume.trim()) errors.push("Prostate Volume is required.");
    if (!formData.postVoidVolume.trim()) errors.push("Post Void Volume is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
       const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );

      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };
      let payload={...patientDetails,...formData}
try {
    setIsLoading(true)

     const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "PROSTATE_TRANSABDOMINAL_IMAGING",
        "createdby": user?.username || '',
        "appurl": window.location.origin,
          // "appurl": "",
        "Exam_Date": formattedDate,
        "data":payload
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,      
        "worksheet_type":"PROSTATE_TRANSABDOMINAL_IMAGING",
         "appurl": window.location.origin,
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          resetForm()
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)
}
    }
  };
const resetForm = () => {
    setFormData({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    reasonForExam: "",
    bladderVolume: "",
    prostateVolume: "",
    postVoidVolume: "",
    impression: "",
    signature: "",
    preliminary: "",
  })}
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">PROSTATE TRANSABDOMINAL IMAGING</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
     #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange("provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.providerid} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={formData.examDate} onChange={(e) => handleChange("examDate", e.target.value)} />
          </div>
        </div>

        <div className="mt-4 flex items-center space-x-6">
          <label className="text-sm font-medium">Preliminary</label>
          <div className="flex items-center space-x-4">
            <label className="flex items-center space-x-1">
              <input type="radio" name="preliminary" value="yes" checked={formData.preliminary === "yes"} onChange={(e) => handleChange("preliminary", e.target.value)} />
              <span className="text-sm">Yes</span>
            </label>
            <label className="flex items-center space-x-1">
              <input type="radio" name="preliminary" value="no" checked={formData.preliminary === "no"} onChange={(e) => handleChange("preliminary", e.target.value)} />
              <span className="text-sm">No</span>
            </label>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea placeholder="Enter Patient History here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.history} onChange={(e) => handleChange("history", e.target.value)} />
        </div>

        <div className="mt-4 grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Reason for Exam</label>
            <input className="w-full border rounded px-2 py-1" placeholder="Reason for Exam" value={formData.reasonForExam} onChange={(e) => handleChange("reasonForExam", e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Bladder Volume</label>
            <input className="w-full border rounded px-2 py-1" placeholder="Bladder Volume" value={formData.bladderVolume} onChange={(e) => handleChange("bladderVolume", e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Prostate Volume</label>
            <input className="w-full border rounded px-2 py-1" placeholder="Prostate Volume" value={formData.prostateVolume} onChange={(e) => handleChange("prostateVolume", e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Post Void Volume</label>
            <input className="w-full border rounded px-2 py-1" placeholder="Post Void Volume" value={formData.postVoidVolume} onChange={(e) => handleChange("postVoidVolume", e.target.value)} />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Sonographer's Impression</label>
          <textarea placeholder="Enter Sonographer's Impression here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.impression} onChange={(e) => handleChange("impression", e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input className="w-full border rounded px-2 py-1 mt-1" placeholder="Signature" value={formData.signature} onChange={(e) => handleChange("signature", e.target.value)} />
        </div>

        <div className="flex justify-end mt-6">
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default ProstateTransAbdorminal;
